import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * The various states that the note editor can be in.
 * `unknown` is a default state — it means a note editor somehow isn't in view.
 */
export type NoteSaveStatus = "saved" | "saving" | "offline" | "unknown";

const NoteSaveStateContext = createContext<{
	saveStatus: NoteSaveStatus;
	updateNoteSaveStatus: (status: NoteSaveStatus) => void;
}>({
	saveStatus: "unknown",
	updateNoteSaveStatus: () => {
		throw new Error("NoteSaveStateContext is missing!");
	},
});

export function NoteSaveStateProvider({ children }: React.PropsWithChildren<{}>) {
	const [saveStatus, setSaveStatus] = useState<NoteSaveStatus>("unknown");

	return (
		<NoteSaveStateContext.Provider
			value={useMemo(() => ({ saveStatus, updateNoteSaveStatus: setSaveStatus }), [saveStatus])}
		>
			{children}
		</NoteSaveStateContext.Provider>
	);
}

export const useNoteSaveState = () => useContext(NoteSaveStateContext);
